export default function LoadingIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" style={{ animation: 'spin 0.5s linear infinite' }}>
      <path d="M8,1 A 7 7 0 0 1 15,8" stroke="currentColor" fill="none" strokeWidth="2" />
    </svg>
  );
}
